import React, { useState, useEffect } from 'react';
import Page from 'react-page-loading';
import { getService, getSkill } from '../api';
import * as _ from 'lodash';

const About = (props) => {
    const { user } = props;
    const [classEl, setClass] = useState("");
    const [services, setServices] = useState([]);
    const [skills, setSkills] = useState([]);

    useEffect(() => {
        let isMounted = true;
        getService((res) => {
            if (res) setServices(res)
        })
        getSkill((res) => {
            if (res) setSkills(res)
        })
        setTimeout(() => {
            if (isMounted) setClass("active")
        }, 300)

        return () => { isMounted = false };
    }, [])

    const serviceList = (list) => {
        const items = []
        for (const [index, value] of list.entries()) {
            items.push(<li key={index}>{value}</li>)
        }
        return items;
    }

    if (_.isEmpty(user)) return false;
    return (

        // {/* <!-- ========== Start About ========== --> */ }

        <section className={`about area-bg ${classEl}`} id="about" >
            {/* <!-- ========== Start About Me ========== --> */}
            <Page loader={"rotate-spin"} color={"#A9A9A9"} size={6} duration={4}>

                <div className="about-me container" >
                    <div className="main-title">
                        <h2>Get to know me</h2>
                        <h3>About Me</h3>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <div className="about-image">
                                <img className="img-fluid" src={user.profile_img} alt="" />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="about-info">
                                <h3>I am {user.name}.</h3>
                                <p>{user.description}</p>

                                <ul className="personal-info list-unstyled">
                                    <li className="about-item">
                                        <h4><span><i className="fa fa-user"></i></span>{user.name}</h4>
                                    </li>
                                    <li className="about-item">
                                        <h4><span><i className="fa fa-skype"></i></span>
                                            <a href={`skype:${user.skype}?chat`} className="user-email-about" target="_blank" rel="noopener noreferrer">{user.skype}</a>
                                        </h4>
                                    </li>
                                    <li className="about-item">
                                        <h4><span><i className="fa fa-envelope"></i></span>
                                            <a href={`mailto:${user.email}`} className="user-email-about">{user.email}</a>
                                        </h4>
                                    </li>
                                    <li className="about-item">
                                        <h4><span><i className="fa fa-map-marker"></i></span>{user.address}</h4>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="my-btn download-cv-btn ">
                            <a href={user.resume} className="main-btn">Download CV</a>
                        </div> */}
                    </div>
                </div >
                {/* <!-- ========== End About Me ========== --> */}

                {/* <!-- ========== Start Services ========== --> */}
                <div className="services container">
                    <div className="main-title">
                        <h2>My Services</h2>
                    </div>
                    <div className="row">
                        {
                            services && services.map((service, key) =>
                                <div className="col-lg-4 col-md-4 col-sm-12" key={key}>
                                    <div className="service one">
                                        <div className="service-icon">
                                            <i className={service.icon}></i>
                                        </div>
                                        <h4>{service.title}</h4>
                                        <p>{serviceList(service.description)}</p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                {/* <!-- ========== End Services ========== --> */}

                {/* <!-- ========== Start Skills ========== --> */}
                <div className="skills container">
                    <div className="main-title">
                        <h2>My Skills</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="skills-content">
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="personal-skills">
                                            <h3>
                                                <i className="fa fa-vcard"></i>
                                                Personal Skills
                                            </h3>
                                            {skills && skills.map((skill, index) => (index + 1) <= skills.length / 2 && (
                                                <div className="personal-skills" key={index}>
                                                    <div className="progress-container">
                                                        <span className="percent">{skill.value}%</span>
                                                        <h4>{skill.name}</h4>
                                                        <div className="progress">
                                                            <div className="progress-bar" role="progressbar" style={{ width: `${skill.value}%` }} aria-valuenow={skill.value} aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="professional-skills">
                                            <h3>
                                                <i className="fa fa-tasks"></i>
                                                Professional Skills
                                            </h3>
                                            {skills && skills.map((skill, index) => (index + 1) > skills.length / 2 && (
                                                <div className="personal-skills" key={index}>
                                                    <div className="progress-container">
                                                        <span className="percent">{skill.value}%</span>
                                                        <h4>{skill.name}</h4>
                                                        <div className="progress">
                                                            <div className="progress-bar" role="progressbar" style={{ width: `${skill.value}%` }} aria-valuenow={skill.value} aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- ========== End Skills ========== --> */}
            </Page>
        </section >

        // {/* <!-- ========== End About ========== --> */ }


    );

}

export { About };
